
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[href]",
      function () {
        return require("private-next-pages/faq/[href]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[href]"])
      });
    }
  